import React, { useEffect, useState } from 'react';
import TabWrapper from './TabWrapper';
import { getListEvaluations } from 'redux/actions/daoUI/challenges.action';
import EvaluationModal from './EvaluationModal';

const EvaluationTab = ({ daoOrganizerAddress, daoId, chainId }) => {
  const [evaluations, setEvaluations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [editingEvaluation, setEditingEvaluation] = useState(null);

  useEffect(() => {
    const fetchEvaluations = async () => {
      setLoading(true);
      setError(null);
      try {
        // getListEvaluations không nhận params, trả về 100 bản ghi tối đa
        const data = await getListEvaluations()();
        setEvaluations(data?.data || []);
        setTotal(data?.data?.length || 0);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };
    fetchEvaluations();
  }, []);

  // Xử lý phân trang phía client
  const pagedEvaluations = evaluations.slice((page - 1) * limit, page * limit);

  return (
    <TabWrapper daoOrganizerAddress={daoOrganizerAddress} chainId={chainId}>
      {loading && <div>Loading...</div>}
      {error && <div style={{ color: 'red' }}>{error.toString()}</div>}
      {!loading && !error && (
        <div>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
            <h3 style={{ color: '#03edc3', marginRight: 8 }}>Evaluations List</h3>
            <button
              onClick={() => { setEditingEvaluation(null); setModalOpen(true); }}
              style={{
                width: 28,
                height: 28,
                borderRadius: '50%',
                background: '#00EDC3',
                border: 'none',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                marginLeft: 4,
                marginBottom: 10,
                boxShadow: '0 2px 8px #0003'
              }}
              title="Create new"
            >
              <span style={{ color: '#fff', fontSize: 20, fontWeight: 'bold', lineHeight: 1 }}>+</span>
            </button>
          </div>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: 0, marginTop: '20px', background: '#23272f', color: '#00ffe0', borderRadius: 8, overflow: 'hidden', boxShadow: '0 2px 8px #0006' }}>
              <thead>
                <tr style={{ backgroundColor: '#181c22' }}>
                  <th style={{ padding: '14px', textAlign: 'left', borderBottom: '2px solid #00ffe0', color: '#00ffe0', fontWeight: 600 }}>Name</th>
                  <th style={{ padding: '14px', textAlign: 'left', borderBottom: '2px solid #00ffe0', color: '#00ffe0', fontWeight: 600 }}>Created Time</th>
                  <th style={{ padding: '14px', textAlign: 'left', borderBottom: '2px solid #00ffe0', color: '#00ffe0', fontWeight: 600 }}>Updated Time</th>
                </tr>
              </thead>
              <tbody>
                {pagedEvaluations.map((evaluation, idx) => (
                  <tr key={evaluation._id}
                    style={{ borderBottom: '1px solid #00ffe0', background: idx % 2 === 0 ? '#23272f' : '#181c22', transition: 'background 0.2s', cursor: 'pointer' }}
                    onMouseOver={e => e.currentTarget.style.background = '#26313a'}
                    onMouseOut={e => e.currentTarget.style.background = idx % 2 === 0 ? '#23272f' : '#181c22'}
                    onClick={() => { setEditingEvaluation(evaluation); setModalOpen(true); }}
                  >
                    <td style={{ padding: '12px', color: '#fff' }}>{evaluation.name}</td>
                    <td style={{ padding: '12px', color: '#fff' }}>{evaluation.createdAt ? new Date(evaluation.createdAt).toLocaleString() : 'Unknown'}</td>
                    <td style={{ padding: '12px', color: '#fff' }}>{evaluation.updatedAt ? new Date(evaluation.updatedAt).toLocaleString() : 'Unknown'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div style={{ marginTop: '20px' }}>
            <button 
              onClick={() => setPage(p => Math.max(1, p - 1))}
              disabled={page === 1}
              style={{
                padding: '8px 16px',
                backgroundColor: '#00ffe0',
                color: '#181c22',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontWeight: 'bold',
                marginRight: '10px',
                opacity: page === 1 ? 0.5 : 1
              }}
            >
              Previous
            </button>
            <span style={{ margin: '0 10px', color: '#fff' }}>Page {page}</span>
            <button 
              onClick={() => setPage(p => p + 1)}
              disabled={page >= Math.ceil(total / limit)}
              style={{
                padding: '8px 16px',
                backgroundColor: '#00ffe0',
                color: '#181c22',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontWeight: 'bold',
                opacity: page >= Math.ceil(total / limit) ? 0.5 : 1
              }}
            >
              Next
            </button>
          </div>
        </div>
      )}
      <EvaluationModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        onSubmit={(data) => {
          // TODO: handle create or update logic here
          setModalOpen(false);
        }}
        initialData={editingEvaluation}
      />
    </TabWrapper>
  );
};

export default EvaluationTab;
